// extracted by mini-css-extract-plugin
export default {"colorPickerContainer":"styles2_colorPickerContainer__-33UQ","colorPreview":"styles2_colorPreview__CH2fr","sliderPicker":"styles2_sliderPicker__Qlgzu"};